module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f6fcd0d885c7e2a50ae71adccf92a99f.png";